module.exports = __webpack_public_path__ + "sprstatic/img/zhifubao.1640394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/zhifubao.png
// module id = nJlR
// module chunks = 2